import Alpine from 'alpinejs'

const WIDGET_SELECTOR = 'input[name="cf-turnstile-response"]'
const WIDGET_WAIT_TIMEOUT = 10000

/**
 *  等待cloudflare驗證結束，才能開啟submit
 *  超過等待上限仍找不到widget時fail-open，避免表單被永久鎖死
 */
const data = (params = {}) => ({
  /**
   *  Data
   */
  cloudflareValue: '',
  widgetMissing: false,

  containerObserver: null,
  valueObserver: null,
  waitTimer: null,

  get hasValue() {
    return this.widgetMissing || this.cloudflareValue.length > 0
  },

  /**
   *  Targets
   */

  targets: {
    form: {
      ['@submit']: 'if ( !hasValue ) $event.preventDefault()'
    }
  },

  /**
   *  Main & Event Callback
   */

  init() {
    const dom = this.$root.querySelector(WIDGET_SELECTOR)
    if (dom) {
      this.observeValue(dom)
      return
    }

    // widget由cloudflare的api.js非同步注入，等它出現在$root內
    this.containerObserver = new MutationObserver(() => {
      const injected = this.$root.querySelector(WIDGET_SELECTOR)
      if (!injected) return

      this.stopWaiting()
      this.observeValue(injected)
    })
    this.containerObserver.observe(this.$root, { childList: true, subtree: true })

    this.waitTimer = setTimeout(() => {
      this.stopWaiting()
      this.widgetMissing = true
      console.error(
        `[DetectCloudflare] 等待 ${WIDGET_WAIT_TIMEOUT / 1000} 秒仍找不到 ${WIDGET_SELECTOR}，` +
        '請確認 cloudflare_turnstile widget 放在掛有 DetectCloudflare 的 form 之內。' +
        '已 fail-open 放行送出，改由後端驗證把關。'
      )
    }, WIDGET_WAIT_TIMEOUT)
  },

  destroy() {
    this.stopWaiting()

    if (this.valueObserver) {
      this.valueObserver.disconnect()
      this.valueObserver = null
    }
  },

  /**
   *  Public Function
   */

  /**
   *  Value Changed
   */

  /**
   *  Private Function
   */

  stopWaiting() {
    if (this.containerObserver) {
      this.containerObserver.disconnect()
      this.containerObserver = null
    }

    if (this.waitTimer) {
      clearTimeout(this.waitTimer)
      this.waitTimer = null
    }
  },

  observeValue(dom) {
    this.cloudflareValue = dom.value

    this.valueObserver = new MutationObserver(() => {
      this.cloudflareValue = dom.value
    })
    this.valueObserver.observe(dom, { attributeFilter: ['value'], attributes: true, attributeOldValue: true })
  },

  ...params
})

Alpine.data('DetectCloudflare', data)
export default data
